import React, {  useMemo, useState } from 'react';
import { useParams } from 'react-router-dom'; 
import { Alert } from 'antd';
import CourseLoader from '../../components/CourseLoader/CourseLoader';
import WidgetCourse from '../../components/WidgetCourse/WidgetCourse';

const WidgetPage = () => {  
    const [ hasError, setHasError ] = useState( false );
    const { courseId } = useParams();

    const queryParams = new URLSearchParams( window.location.search );
    const [ token ] = useState( queryParams.get( 'token' ) ); 
    const [ learnerId ] = useState( queryParams.get( learnerId ) || '' );
    const [ learnerFirstName ] = useState( queryParams.get( learnerFirstName ) || '' );
    const [ learnerLastName ] = useState( queryParams.get( learnerLastName ) || '' );
    const [ locale ] = useState( queryParams.get( 'locale' ) || 'en-US' );
    const [ referrer ] = useState( queryParams.get( 'referrer' )  || '' );

    const courseOptions = useMemo( () => {
        if ( token && courseId ) {
            const result = { token, courseId, learnerId, 
                learnerFirstName, learnerLastName, locale, referrer };
            return result;
        } else {
            setHasError( true );
            return undefined;
        }
    }, [] );

    return (
        <div>
            { hasError && 
                <Alert
                    message="Error"
                    description="The url for this course has incorrect or missing data."
                    type="error" 
                    style={ {
                        margin: '40px'
                    } }
                /> 
            }
            
            { courseOptions && 
                <CourseLoader courseOptions={ courseOptions }>
                    <WidgetCourse/>
                </CourseLoader>
            }
        </div>
    );
};

export default WidgetPage;
